






































































































import {Component, Mixins} from 'vue-mixin-decorator';
import {getModule} from 'vuex-module-decorators';

import {Notify} from '@/utils/Notify';

import {FileChange, ChangeType} from '@/model/system/storage/FileChange';

import SystemStorageStore from '@/store/system/SystemStorage.store';

import {BaseComponent} from '@/mixins/BaseComponent';

interface TreeViewElement {
  id: number;
  name: string;
  children: TreeViewElement[];
  file?: FileChange;
}

@Component({
  components: {},
})
export default class SystemStorageUserData extends Mixins<BaseComponent>(BaseComponent) {
  private storageStore: SystemStorageStore = getModule(SystemStorageStore, this.$store);

  private search: string = '';
  private searchDebounced: string = '';
  private debounceTimer: any;
  private searchLoading: boolean = false;

  private fileChanges: TreeViewElement | null = null;

  private fileIndex = 0;

  private ChangeType = ChangeType;

  private async mounted() {
    await this.refresh();
  }

  private async refresh() {
    this.setLoading();
    try {
      await this.storageStore.fetchUserChanges();

      if (!this.storageStore.UserChanges) {
        return;
      }

      this.fileIndex = 0;

      this.fileChanges = {
        id: this.fileIndex,
        name: 'root',
        children: [],
      };

      for (const file of this.storageStore.UserChanges) {
        this.addFileToTree(file.Path.substring(1), file, this.fileChanges);
      }

    } catch (error) {
      Notify.Error(this.logger, 'Could not get file changes', error);
    } finally {
      this.setLoaded();
    }
  }

  private addFileToTree(path: string, file: FileChange, treeElement: TreeViewElement) {

    if (!path.includes('/')) {
      if (path !== '') {
        treeElement.children.push({
          id: this.fileIndex++,
          name: path,
          children: [],
          file,
        });
      }
      return;
    }

    const pathSplit = path.split('/');
    const root = pathSplit.shift();

    for (const child of treeElement.children) {
      if (child.name === root) {
        this.addFileToTree(pathSplit.join('/'), file, child);
        return;
      }
    }
  }

  get open(): number[] {
    if (!this.searchDebounced) {
      return [];
    } else {
      return Array.from(Array(this.fileIndex).keys());
    }
  }

  private debounceSearch() {
    this.searchLoading = true;
    clearTimeout(this.debounceTimer);
    this.debounceTimer = setTimeout(() => {
      this.searchDebounced = this.search;
      this.searchLoading = false;
    }, 500);
  }

  private searchHandler(item: TreeViewElement, search: string, textKey: string): boolean {
    return item.name.includes(search) ?? false;
  }
}
